import { render, staticRenderFns } from "./KeywordLanguage.vue?vue&type=template&id=1c213217&scoped=true&"
import script from "./KeywordLanguage.vue?vue&type=script&lang=js&"
export * from "./KeywordLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c213217",
  null
  
)

export default component.exports